import * as Yup from 'yup';


export const initialValues = {
    actualStartDate: null,
    actualEndDate: null,
    supportModality: '',
    incidentDescription: '',
};

export const validationSchema = Yup.object({
    actualStartDate: Yup.string().required('error_required_field'),
    actualEndDate: Yup.string().required('error_required_field'),
    supportModality: Yup.string().required('error_required_field'),
    incidentDescription: Yup.string().required('error_required_field'),
});
